<script>
import Drawer from "@/components/drawer.vue";
import Swal from "sweetalert2";
import MultiSelect from "vue-multiselect";
import DatePicker from "vue2-datepicker";

// Custom Components
import PageHeader from "@/components/page-header";
import WakeUpForm from "@/components/superAdmin/WakeUpCall/WakeUpForm.vue";
import Pagination from "@/components/Pagination.vue";
import PbxService from "@/helpers/APIService/pbx.service";
import HandleLogic from "@/helpers/handleLogic";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import appConfig from "@/app.config";
import moment from "moment";

export default {
  page: {
    title: "Wakeup Call",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    WakeUpForm,
    PageHeader,
    MultiSelect,
    DatePicker,
    Pagination,
  },
  data() {
    return {
      title: "Wakeup Call",
      table: {
        tableData: [],
        totalPages: 1,
        pageNumber: 1,
        size: 50,
      },
      wakeUpCallList: [],
      isShowWakeUpCallForm: false,
      selectedwakeUpCall: null,
      isLoading: false,
      isEdit: false,
      isFilterLoading: false,
      filters: {
        domain: "",
        wakeup_time: "",
      },
      domainOptions: [],
    };
  },
  mounted() {
    this.getWakeupCallList();
  },
  methods: {
    // Method is used to get doamin list
    async getWakeupCallList(filter) {
      this.isLoading = true;
      try {
        this.table.tableData = [];
        const response = await PbxService.getWakeUpCallList(filter);
        if (response) {
          this.isLoading = false;
          this.isFilterLoading = false;
          if (response.status == false) {
            return Middleware.notification(response.message, "warning");
          }
          this.table.totalPages = response.total_pages;
          this.table.pageNumber = response.page_number;
          this.table.tableData = response.result;
          if (this.domainOptions.length !== 0) return;
          const domainOpArray = [];
          response.result.map((item) => {
            domainOpArray.push({
              text: item.domain,
              value: item.domain_uuid,
            });
          });
          this.domainOptions = HandleLogic.uniqueArrayHandle(
            domainOpArray,
            "value"
          );
        }
      } catch (error) {
        this.isFilterLoading = false;
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to handle PBX form
    DomainForm() {
      this.isEdit = false;
      this.selectedwakeUpCall = null;
      this.isShowWakeUpCallForm = !this.isShowWakeUpCallForm;
    },
    wakeUpEdit(wakeUpDetail) {
      this.isEdit = true;
      this.selectedwakeUpCall = wakeUpDetail;
      this.isShowWakeUpCallForm = !this.isShowWakeUpCallForm;
    },
    // Method is used to handle hotel submission
    handleDomainubmit() {
      this.DomainForm();
    },
    changeStatus(domain) {
      PbxService.updateDomainStatus(domain.domain_uuid, {
        domain_enabled: String(!domain.domain_enabled),
      })
        .then((response) => {
          if (response.status == false) {
            return Middleware.notification(response.message, "warning");
          }
          Middleware.notification("Status change successfully !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    timeZoneTime() {
      return moment().zone(60);
    },
    updateWakeUp(wakeUpCall) {
      this.wakeUpEdit(wakeUpCall);
    },
    deleteWakeUpCall(id, id2, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          PbxService.deleteWakeUpCall(id, id2)
            .then((response) => {
              if (response.status == false) {
                return Middleware.notification(response.message, "warning");
              }
              Middleware.notification(
                "Wakeup call deleted successfully !!",
                "danger"
              );
              this.table.tableData.splice(index, 1);
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    // Method is used to handle appy filter
    filterApply(filter_process) {
      this.isFilterLoading = true;
      if (filter_process == "clear") {
        this.filters = {
          domain: "",
          wakeup_time: "",
        };
        this.getWakeupCallList(`?page_size=${this.table.size}`);
      } else {
        let isFirstFilterAssing = false;
        let query = "";
        if (this.filters.domain !== "") {
          !isFirstFilterAssing
            ? (query += `?domain_uuid=${this.filters.domain.value}`)
            : (query += `&domain_uuid=${this.filters.domain.value}`);
          isFirstFilterAssing = true;
        }
        if (
          this.filters.wakeup_time !== "" &&
          this.filters.wakeup_time !== null
        ) {
          !isFirstFilterAssing
            ? (query += `?wakeup_time=${this.filters.wakeup_time}`)
            : (query += `&wakeup_time=${this.filters.wakeup_time}`);
          isFirstFilterAssing = true;
        }
        if (isFirstFilterAssing && query !== "") {
          this.getWakeupCallList(query);
        } else {
          this.isFilterLoading = false;
        }
      }
    },
    onPageChange(page) {
      this.getWakeupCallList(
        `?page_number=${page}&page_size=${this.table.size}`
      );
    },
  },
};
</script>
<template>
  <div>
    <PageHeader
      :title="title"
      :action="DomainForm"
      text="Add Wakeup call"
      :isButton="true"
    />
    <b-card>
      <div class="row align-items-center">
        <div class="col-sm-4 col-md-2 col-lg-2 col-xl-2">
          <MultiSelect
            class="mb-2"
            v-model="filters.domain"
            :options="domainOptions"
            :show-labels="false"
            placeholder="Search with domain"
            track-by="value"
            label="text"
            name="domains"
          />
        </div>
        <div class="col-sm-4 col-md-2 col-lg-2 col-xl-2">
          <date-picker
            class="mb-2"
            v-model="filters.wakeup_time"
            type="date"
            id="wake_up_time"
            placeholder="Select date and time"
            value-type="format"
          ></date-picker>
        </div>

        <div class="col-xl-2 col-lg-2 col-md-8">
          <button
            class="btn btn-primary float-end float-lg-start mb-2 me-2"
            @click="filterApply('apply')"
            :disabled="isFilterLoading"
          >
            Apply Filter
          </button>
          <button
            class="btn btn-primary float-end float-lg-start mb-2"
            @click="filterApply('clear')"
            :disabled="isFilterLoading"
          >
            Clear Filter
          </button>
        </div>
      </div>
      <div class="table-responsive">
        <v-table
          class="table table-hover mb-0"
          ref="my-table"
          infinite-scroll-disabled="busy"
          infinite-scroll-distance="10"
          :data="table.tableData"
        >
          <thead class="table-light" slot="head">
            <tr>
              <v-th sortKey="extension">Room</v-th>
              <v-th sortKey="domain">Domain</v-th>
              <th>Wake Up Time</th>
              <th>Dialed Time</th>
              <v-th sortKey="retry">Retry</v-th>
              <v-th sortKey="domain_timezone">Current Time</v-th>
              <th>Created At</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody
            v-if="!isLoading && table.tableData.length > 0"
            class="infinite-list"
            slot="body"
            slot-scope="{ displayData }"
          >
            <tr v-for="(wakeUpCall, index) in displayData" :key="index">
              <td>
                {{ wakeUpCall.extension ? wakeUpCall.extension : "--" }}
              </td>
              <td>
                {{ wakeUpCall.domain ? wakeUpCall.domain : "-" }}
              </td>
              <td>
                {{
                  global_format_date_and_time_custom(
                    wakeUpCall.wakeup_time,
                    "DD/MM/YYYY - hh:mm A"
                  )
                }}
              </td>
              <td>
                {{
                  wakeUpCall.alarm_time
                    ? global_format_date_and_time_custom(
                        wakeUpCall.alarm_time,
                        "DD/MM/YYYY - hh:mm A"
                      )
                    : "--"
                }}
              </td>

              <td>
                {{ wakeUpCall.retry ? wakeUpCall.retry : "--" }}
              </td>
              <td>
                {{ wakeUpCall.domain_timezone }}
              </td>
              <td>
                {{
                  global_format_date_and_time_custom(
                    wakeUpCall.created_at,
                    "DD/MM/YYYY - hh:mm A"
                  )
                }}
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <i
                    v-b-popover.hover="'Delete'"
                    class="mdi mdi-trash-can text-danger fs-5 ms-2"
                    @click="
                      deleteWakeUpCall(
                        wakeUpCall.domain_uuid,
                        wakeUpCall.wakeupcall_uuid,
                        index
                      )
                    "
                  ></i>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="!isLoading && table.tableData == 0">
            <tr>
              <td colspan="9" class="text-center">
                <img src="@/assets/images/empty.svg" class="img-fluid" alt="" />
                <p>
                  <span class="text-secondary">No Data Found</span>
                </p>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="item in 20" :key="item">
              <td class="placeholder-glow" v-for="no in 8" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
        </v-table>
      </div>
      <Pagination
        v-if="table.tableData.length !== 0"
        :totalPages="table.totalPages"
        :currentPage="table.pageNumber"
        @pagechanged="onPageChange"
      />
    </b-card>

    <Drawer
      @close="DomainForm"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1000"
    >
      <div v-if="isShowWakeUpCallForm">
        <WakeUpForm
          :WakeUpForm="this.selectedwakeUpCall"
          :isEdit="this.isEdit"
          @cancelSubmit="DomainForm"
          @submitted="handleDomainubmit"
        />
      </div>
    </Drawer>
  </div>
</template>

<style scoped>
.w-250 {
  width: 250px;
}
</style>
